import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { RouteComponentProps, Link } from 'react-router-dom';
import { Globals, Constants, Colors, Print, checkPermission } from 'utils';
import { Table, Pagination, Tooltip, Input, DatePicker, Select, Modal } from 'components';
import type { SortableColumn } from 'components/table';
import {
  CleanIcon,
  TrashIcon,
  EditIcon,
  AddIcon,
  ModeratorsIcon,
  UsersIcon,
  LawyersIcon,
  DownloadExcelIcon,
  ViewIcon,
  ToggleGreen,
  ToggleRed,
} from 'assets/icons';
import ModalCreate from './modal-create';
import { UserService } from 'services';
import moment from 'moment';
import ModalView from '../modal-view';

declare var window: any;

interface Props extends RootState, RouteComponentProps {
  dispatch: any;
}

const INITIAL_STATE = {
  search: '',
  date: '',
};

const SORTABLE_COLUMNS: SortableColumn[] = [
  { index: 0, key: 'created_at', type: 'date' },
  { index: 1, key: 'full_name', type: 'string' },
  { index: 4, key: 'email', type: 'string' },
  {
    index: 5,
    key: 'membership_name',
    type: 'string',
    accessor: (item: any) => (item.plan_user?.length ? item.plan_user[0].membership?.name : null),
  },
  { index: 6, key: 'status', type: 'number' },
];

class AdminUsers extends React.Component<Props> {
  timer: any = undefined;

  state = {
    header: [
      'Fecha de Registro',
      'Nombre',
      'C.I.',
      'Teléfono',
      'Correo',
      'Membresía',
      'Estatus',
      'Acciones',
    ],
    form: INITIAL_STATE,
    data: [],
    originalData: [] as any[],
    page: 1,
    last_page: 1,
    visible: false,
    item: null,
    visible_view: false,
  };

  componentDidMount() {
    this.props.dispatch({
      type: 'SET_HEADER',
      payload: {
        title: 'Clientes',
        onBack: null,
      },
    });

    this.props.dispatch({
      type: 'SET_SUBHEADER',
      payload: {
        title: '',
      },
    });

    this.load();
  }

  load = async (withoutLoading: boolean = false) => {
    const res: any = await UserService.admin.get({
      withoutLoading,
      page: this.state.page,
      ...this.state.form,
      date: this.state.form.date && moment(this.state.form.date).format('YYYY-MM-DD'),
    });
    this.setState({
      data: res.users.rows,
      originalData: [...res.users.rows],
      last_page: res.users.count,
    });
  };

  reset = () => {
    this.setState(
      {
        form: INITIAL_STATE,
        page: 1,
      },
      () => this.load(true),
    );
  };

  edit = (e: any, item: any) => {
    e.preventDefault();
    this.setState({
      visible: true,
      item,
    });
  };

  delete = (e: any, item: any) => {
    e.preventDefault();
    Globals.confirm('¿Desea eliminar el cliente?', async () => {
      await UserService.admin.delete({
        user_id: item.id,
      });
      this.load(true);
    });
  };

  change = (e: any, callback = () => {}) => {
    this.setState(
      {
        page: 1,
        form: {
          ...this.state.form,
          [e.target.name]: e.target.value,
        },
      },
      callback,
    );
  };

  add = () => {
    this.setState({
      visible: true,
    });
  };

  onClose = () => {
    this.setState(
      {
        visible: false,
        item: null,
      },
      () => this.load(true),
    );
  };

  download = async (segment?: 'SQL') => {
    // Igual que en lawyers.tsx: un solo método, solo cambia qué método del
    // servicio se invoca según el botón presionado.
    const serviceMethod =
      segment === 'SQL' ? UserService.admin.downloadSQL : UserService.admin.download;

    const res: any = await serviceMethod({
      ...this.state.form,
    });
    if (window.webkit && window.webkit.messageHandlers) {
      const message = 'open_url';
      const sendToNative = {
        message,
        url: Constants.BASE_STORAGE + res.url,
      };
      const stringifiedMessageObj = JSON.stringify(sendToNative);
      window.webkit.messageHandlers.cordova_iab.postMessage(stringifiedMessageObj);
    } else {
      Print(Constants.BASE_STORAGE + res.url);
    }
  };

  onCloseView = () => {
    this.setState({
      visible_view: false,
      item: null,
    });
  };

  view = (e: any, item: any) => {
    e.preventDefault();
    this.setState({
      visible_view: true,
      item,
    });
  };

  changeActive = (e: any, item: any) => {
    e.preventDefault();
    let message = '';
    let message_confirm = '';

    switch (item.status) {
      case Constants.USER_STATUS.ACTIVE:
        message = '¿Desea suspender el usuario?';
        message_confirm = 'Se ha suspendido el usuario';
        break;

      case Constants.USER_STATUS.INACTIVE:
        message = '¿Desea activar el usuario?';
        message_confirm = 'Se ha activado el usuario';
        break;
    }

    Globals.confirm(message, async () => {
      await UserService.admin.changeActive({
        user_id: item?.id,
      });
      this.load();
      Globals.showSuccess(message_confirm);
    });
  };

  render() {
    const { visible, visible_view } = this.state;

    return (
      <div id='admin-users'>
        <Modal
          className='modal-create-user'
          visible={visible}
          title={`${this.state.item ? 'Editar' : 'Crear'} usuario`}
          onClose={() => this.onClose()}
        >
          <ModalCreate item={this.state.item} onClose={() => this.onClose()} />
        </Modal>

        <Modal
          className='modal-view-user'
          visible={visible_view}
          title={''}
          onClose={() => this.onCloseView()}
        >
          <ModalView
            edit={() => {
              this.setState({
                visible_view: false,
                visible: true,
              });
            }}
            item={this.state.item}
            onClose={() => this.onCloseView()}
          />
        </Modal>

        <TabsTop history={this.props.history} active={TABS.CLIENTS} />

        <div className='row row-filter'>
          <div className='col-md-12'>
            <div className='row'>
              <div className='col-md-4'>
                <Input
                  value={this.state.form.search}
                  name='search'
                  placeholder='Buscar'
                  label='Nombre, correo o cédula'
                  className='input-table'
                  onSubmit={() => this.load()}
                  onChange={(e: any) => {
                    clearTimeout(this.timer);
                    this.timer = setTimeout(() => {
                      this.load(true);
                    }, 1000);
                    this.change(e);
                  }}
                />
              </div>
              <div className='col-md-4'>
                <DatePicker
                  label='Fecha de Registro'
                  placeholder='Fecha'
                  maxDate={moment().toDate()}
                  onChange={(text: string) => {
                    this.change(
                      {
                        target: {
                          value: text,
                          name: 'date',
                        },
                      },
                      () => this.load(true),
                    );
                  }}
                  value={this.state.form.date}
                />
              </div>
              <div className='col-md-1'>
                {this.state.form != INITIAL_STATE && (
                  <button className='btn btn-clean' onClick={() => this.reset()}>
                    <img src={CleanIcon} />
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>

        <Table
          title='Clientes'
          data={this.state.data.length}
          header={this.state.header}
          sortableColumns={SORTABLE_COLUMNS}
          rawData={this.state.originalData}
          onSort={(sorted) => this.setState({ data: sorted })}
          rightAlign={[7]}
          titleRight={
            <>
              {this.state.data.length > 0 && (
                <div className='container-btns-table'>
                  <button className='btn download-excel' onClick={() => this.download()}>
                    <img src={DownloadExcelIcon} />
                    <p>Descargar Excel</p>
                  </button>
                  <button className='btn download-excel' onClick={() => this.download('SQL')}>
                    <img src={DownloadExcelIcon} />
                    <p>Descargar SQL</p>
                  </button>
                </div>
              )}
            </>
          }
        >
          {this.state.data.map((i: any, index: number) => {
            return (
              <tr key={index}>
                <td>{moment(i.created_at).format('DD/MM/YYYY')}</td>
                <td>{i.full_name}</td>
                <td style={{ whiteSpace: 'nowrap' }}>{i.full_document}</td>
                <td>{i.full_phone}</td>
                <td>{i.email}</td>
                <td>
                  {i.plan_user
                    ? !!i.plan_user.length
                      ? i.plan_user[0].membership?.name
                      : '-'
                    : '-'}
                </td>
                <td>{i.status_text}</td>
                <td className='text-right'>
                  <Tooltip title='Ver'>
                    <a className='link-icon' href='#' onClick={(e: any) => this.view(e, i)}>
                      <img src={ViewIcon} />
                    </a>
                  </Tooltip>
                  {checkPermission(Constants.MODULES.USERS, 'write') && (
                    <Tooltip title='Editar'>
                      <a className='link-icon' href='#' onClick={(e: any) => this.edit(e, i)}>
                        <img src={EditIcon} />
                      </a>
                    </Tooltip>
                  )}
                  {checkPermission(Constants.MODULES.USERS, 'delete') && (
                    <Tooltip title='Eliminar'>
                      <a className='link-icon' href='#' onClick={(e: any) => this.delete(e, i)}>
                        <img src={TrashIcon} />
                      </a>
                    </Tooltip>
                  )}
                  {checkPermission(Constants.MODULES.USERS, 'write') && (
                    <Tooltip
                      title={i.status == Constants.USER_STATUS.ACTIVE ? 'Suspender' : 'Activar'}
                    >
                      <a
                        className='link-icon link-status'
                        href='#'
                        onClick={(e: any) => this.changeActive(e, i)}
                      >
                        <img
                          src={i.status == Constants.USER_STATUS.ACTIVE ? ToggleGreen : ToggleRed}
                        />
                      </a>
                    </Tooltip>
                  )}
                </td>
              </tr>
            );
          })}
        </Table>

        <Pagination
          pages={this.state.last_page}
          active={this.state.page}
          onChange={async (page: number) => {
            await this.setState({
              page: page,
            });
            this.load();
          }}
        />
      </div>
    );
  }
}

export default connect((state: RootState) => {
  return {
    user: state.user,
  };
})(AdminUsers);

const TabsTop = (props: any) => {
  return (
    <div className='row row-tabs'>
      <div className='col-md-4'>
        <div
          className={`item-tab ${props.active == TABS.CLIENTS ? 'active' : ''}`}
          onClick={() => props.history.replace('/admin/users/clients')}
        >
          <img src={UsersIcon} />
          <p className={props.active == TABS.CLIENTS ? 'active' : ''}>Clientes</p>
        </div>
      </div>
      <div className='col-md-4'>
        <div
          className={`item-tab ${props.active == TABS.LAWYERS ? 'active' : ''}`}
          onClick={() => props.history.replace('/admin/users/lawyers')}
        >
          <img src={LawyersIcon} />
          <p className={props.active == TABS.LAWYERS ? 'active' : ''}>Abogados</p>
        </div>
      </div>
      <div className='col-md-4'>
        <div
          className={`item-tab ${props.active == TABS.MODERATORS ? 'active' : ''}`}
          onClick={() => props.history.replace('/admin/users/moderators')}
        >
          <img src={ModeratorsIcon} />
          <p className={props.active == TABS.MODERATORS ? 'active' : ''}>Moderadores</p>
        </div>
      </div>
    </div>
  );
};

const TABS = {
  CLIENTS: 1,
  LAWYERS: 2,
  MODERATORS: 3,
};

export { TABS, TabsTop };
